<template>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import jscookie from 'js-cookie'

export default {
data () {
	return {
	}
},

created: function () {
	//jscookie.remove('if_use_beta_gis')
	//console.log(jscookie.get('if_use_beta_gis'))
	
	/*if (jscookie.get('if_use_beta_gis') == 'false') { 
		jscookie.set('if_use_beta_gis', true) 
		console.log("cookie was equal to false, setting true")
	} else {
		console.log("cookie was equal to true, setting false")
		jscookie.set('if_use_beta_gis', false)
	}*/

	jscookie.set('if_use_beta_gis', true) 
	console.log("setBetaGIS mutation", jscookie.get('if_use_beta_gis'))
	this.$store.commit('setUseBetaGIS', true)
	this.$router.push('/')	

/*	this.$store.dispatch('logout').then(() => {
	        	this.$router.push('/')	
	        	})*/
},

methods : {},

}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/setBetaGIS.vue